import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import {
    fetchAccounts,
    fetchAddPayment,
    fetchDataForEdit,
    fetchDataForSecondStep,
    fetchPayments,
    fetchPaymentsFilters,
    fetchPaymentsForEdit,
} from './action';

const paymentAdapter = createEntityAdapter({
    selectId: (payment) => payment.guid,
});
const initialState = {
    payments: paymentAdapter.getInitialState(),
    accountsSelectList: [],
    archiveAccountList: [],
    estimatesSelectList: [],
    expenseList: [],
    incomeList: [],
    partnersSelectList: [],
    isLoadingPayments: false,
    isLoadingFilters: false,
    isLoadingDataForEdit: false,
    filter: {
        page: 1,
        'accounts[]': [],
        payment_start_date: '',
        payment_end_date: '',
        accrual_start_date: '',
        accrual_end_date: '',
        sum_from: '',
        sum_to: '',
        payment_item: '',
        correspondent: '',
        project: '',
        status: '',
    },
    queryString: '',
    isActiveFilter: false,
    pagination: {
        count: 1,
        current: 1,
    },
};

export const paymentSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
        removePayment: (state, action) => {
            paymentAdapter.removeOne(state.payments, action.payload);
        },
        updatePayment: (state, action) => {
            paymentAdapter.updateOne(state.payments, action.payload);
        },
        updatePartnerList: (state, action) => {
            state.partnersSelectList = action.payload;
        },
        changeFilters: (state, action) => {
            state.filter = action.payload;
        },
        changeIsActiveFilters: (state, action) => {
            state.isActiveFilter = action.payload;
        },
        setQueryString: (state, action) => {
            state.queryString = action.payload || '';
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPayments.fulfilled, (state, action) => {
                paymentAdapter.addMany(state.payments, action.payload.payments);
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchPaymentsForEdit.pending, (state, action) => {
                state.isLoadingFilters = true;
            })
            .addCase(fetchPaymentsForEdit.fulfilled, (state, action) => {
                state.isLoadingFilters = false;
                paymentAdapter.setAll(state.payments, action.payload.payments);
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchAddPayment.fulfilled, (state, action) => {
                paymentAdapter.setAll(state.payments, action.payload.payments);
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchPaymentsFilters.fulfilled, (state, action) => {
                state.isLoadingPayments = false;
                paymentAdapter.setAll(state.payments, action.payload.payments);
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchPaymentsFilters.pending, (state, action) => {
                state.isLoadingPayments = true;
            })
            .addCase(fetchPaymentsFilters.rejected, (state, action) => {
                state.isLoadingPayments = false;
            })

            .addCase(fetchAccounts.fulfilled, (state, action) => {
                const { accountsList, accountsListArchive } = action.payload;
                state.accountsSelectList = accountsList;
                state.archiveAccountList = accountsListArchive;
            })
            .addCase(fetchDataForEdit.pending, (state, action) => {
                state.isLoadingDataForEdit = true;
            })
            .addCase(fetchDataForEdit.fulfilled, (state, action) => {
                const {
                    accountsList,
                    expenseList,
                    incomeList,
                    partnersList,
                    estimatesList,
                    accountsListArchive,
                } = action.payload;
                state.isLoadingDataForEdit = false;
                state.accountsSelectList = accountsList;
                state.estimatesSelectList = estimatesList;
                state.expenseList = expenseList;
                state.incomeList = incomeList;
                state.partnersSelectList = partnersList;
                state.archiveAccountList = accountsListArchive;
            })
            .addCase(fetchDataForSecondStep.fulfilled, (state, action) => {
                const { expenseList, incomeList, partnersList, estimatesList } = action.payload;
                state.estimatesSelectList = estimatesList;
                state.expenseList = expenseList;
                state.incomeList = incomeList;
                state.partnersSelectList = partnersList;
            });
    },
});

export const paymentSelector = paymentAdapter.getSelectors(
    (state) => state.paymentReducer.payments
);

export const { actions: paymentActions } = paymentSlice;
export const { reducer: paymentReducer } = paymentSlice;
